import React from "react";
import { python } from '@codemirror/lang-python';
import CodeMirror, { lineNumbers } from '@uiw/react-codemirror';
import { vscodeDark } from '@uiw/codemirror-theme-vscode';


const CodeEditor = (props) => {
    const { code, editable, setCode } = props;
    const [value, setValue] = React.useState("");
    React.useEffect(() => {
        setCode(code);
        setValue(code);
    }, [code])
    const onChange = React.useCallback((val) => {
        setValue(val);
        setCode(val);
    }, [setCode]);
    return (<>
        <div className="cell-row">
            <div className="cell-content source-code">
                <div className="source-code-main">
                    <CodeMirror
                        readOnly={!editable}
                        value={value}
                        theme={vscodeDark}
                        extensions={[python(), lineNumbers()]}
                        onChange={onChange}
                        minHeight="50px"
                    />
                </div>
            </div>
        </div>
    </>
    )
}

export default CodeEditor;